import { BadgePercent, Calculator, Languages } from 'lucide-react';

export const createInstruction = (title, filename = '') => ({
  title,
  filename,
  url: filename ? `${process.env.PUBLIC_URL}/documents/${filename}` : '',
});
export const DISCOUNT_INSTRUCTION = createInstruction(
  'Instrukcja rabatowania umowy',
  '03_07-instrukcja-automatyzacja_cen.pdf',
);
// Uzupełnij treść komunikatu wyświetlanego w sekcji „Zmiany”.
export const DISCOUNT_CHANGES_MESSAGE = {
  dateTime: '2026-10-04',
  dateLabel: '04.10.2026 r.',
  items: [
    'Dwa tryby pracy: „Tylko rabat” oraz „Narzut + rabat”.',
    'Możliwość usunięcia informacji o technologu z oferty.',
    'Możliwość wyświetlenia informacji o rabacie w pliku PDF.',
  ],
};
// Uzupełnij nazwę pliku po dodaniu instrukcji do frontend/public/documents.
export const MONTAGE_INSTRUCTION = createInstruction('Instrukcja naliczania montażu', 'instrukcja_naliczanie_kosztów_montazu_umowy-alu.pdf');
export const TRANSLATION_INSTRUCTION = createInstruction('Instrukcja tłumaczenia umów');
export const SELECT_INSTALLATION = 'Wybierz typ montażu';
export const SELECT_CONSTRUCTION = 'Wybierz konstrukcję';
export const NOT_APPLICABLE = 'Nie dotyczy';
export const FACADE_TYPES = new Set(['FASADA', 'FASADA DOCIEPLANA']);
export const FACADE_SERVICE_TYPES = new Set(['DEMONTAŻ_FASADY', 'UTYLIZACJA_FASADY']);
export const DISCOUNT_CURRENCIES = ['PLN', 'EURO', 'CZK'];
export const TRANSPORT_OPTIONS = [
  { value: 'TRANSPORT_STOLARKI_BUS', label: 'Transport stolarki do 1,0 t (BUS)' },
  { value: 'TRANSPORT_STOLARKI_CIEZAROWKA', label: 'Transport stolarki ciężarówką od 7 t' },
];

export const ALUMINIUM_SECTIONS = [
  {
    key: 'discount',
    path: '/sales/aluminium-deals/discount',
    label: 'Rabatowanie',
    icon: BadgePercent,
    permission: 'aluminium_deals:use',
  },
  {
    key: 'montage',
    path: '/sales/aluminium-deals/montage',
    label: 'Naliczanie montaży',
    icon: Calculator,
    permission: 'aluminium_deals:montage',
  },
  {
    key: 'translation',
    path: '/sales/aluminium-deals/translation',
    label: 'Tłumaczenie umów',
    icon: Languages,
    permission: 'aluminium_deals:translation',
  },
];
